/**
 * @generated SignedSource<<f5cc93cdcd9803626bacaec2906a5e6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pages"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "pages",
        "variableName": "pages"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateDocumentInstance",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateDocumentInstanceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateDocumentInstanceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "267a12b73e15c61d81f7bdb69b027b4a",
    "id": null,
    "metadata": {},
    "name": "UpdateDocumentInstanceMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateDocumentInstanceMutation(\n  $id: ID!\n  $pages: [DocumentSectionInput!]!\n) {\n  updateDocumentInstance(id: $id, pages: $pages) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "b862a1a621802fab8729ab0a5f9d1021";

export default node;
